// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"47":"8ae3e7f3e805246e95c4","160":"4670d144ce5f4e430b0c","384":"43443a1392f661152830","747":"afc315254abb856e9b62","894":"5f3abf6763157a40bb17"}[chunkId] + ".js";
};